import { render, staticRenderFns } from "./PlcCover.vue?vue&type=template&id=50c63c14&scoped=true"
import script from "./PlcCover.vue?vue&type=script&lang=js"
export * from "./PlcCover.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c63c14",
  null
  
)

export default component.exports